import { render, staticRenderFns } from "./MotorClaimPost.vue?vue&type=template&id=78a19ced&"
import script from "./MotorClaimPost.vue?vue&type=script&lang=js&"
export * from "./MotorClaimPost.vue?vue&type=script&lang=js&"
import style0 from "./MotorClaimPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorClaimPost.vue"
export default component.exports